import { render, staticRenderFns } from "./ServeDispose.vue?vue&type=template&id=3ab84412&scoped=true&"
import script from "./ServeDispose.vue?vue&type=script&lang=js&"
export * from "./ServeDispose.vue?vue&type=script&lang=js&"
import style0 from "./ServeDispose.vue?vue&type=style&index=0&id=3ab84412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab84412",
  null
  
)

export default component.exports